import {
  Box,
  Button,
  Modal,
  Skeleton,
  Typography,
  Drawer,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoopIcon from "@mui/icons-material/Loop";
import React, { useCallback, useEffect, useState, useRef } from "react";
import styles from "./Tasks.module.css";
import CompletedCard from "./CompletedCard/CompletedCard";
import { useNavigate, useLocation } from "react-router-dom";
import TaskKanbanHeader from "./TaskKanbanHeader/TaskKanbanHeader";
import High from "./Assets/High.svg";
import Normal from "./Assets/Normal.svg";
import Low from "./Assets/Low.svg";
import Urgent from "./Assets/Urgent.svg";
import moment from "moment";
import "moment-timezone";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import dayjs from "dayjs";
import DateRangePicker from "../../../../components/DateRangePicker/DateRangePicker";
import getAccessStatus, {
  checkSubDomainAccess,
  getSubDomainAccessStatus,
} from "../../../../components/RolePermissionAccess/RolePermissionAccess";
import {
  resetCreatePaymentSuccessForTask,
  resetCommentStatuses,
  resetEditTaskSuccess,
  resetDeleteTaskSuccess,
  resetTaskSuccess,
} from "../../Nurture/service/nurtureSlice";
import { useDispatch } from "react-redux";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";
import getTeamMember, {
  formatTaskCategory,
} from "../../../../components/CommonFunctions/CommonFunctions";
import { GetTaskBoard } from "../service/tasks.request";
import InfiniteScroll from "react-infinite-scroll-component";
import { getDescriptionWithMentionedNames } from "../../../../components/CommonFunctions/CommonFunctions";
import {
  setTrigger,
  toggleTaskTrigger,
} from "../../Main/service/taskBoardUpdationSlice";
import { clearTaskBoardRefresh } from "../../../../service/websocketNotificationsSlice";
import { openLeadExpandModal } from "../../../../components/LeadPopup/hooks/useLeadCard";
import Remainder from "../../../../assets/images/remainder.svg";
import RemainderPopup from "./RemainderPopup";
import {
  resetSendRemainders,
  getTaskById,
  resetTaskById,
  resetTaskUpdateSuccess,
} from "../service/tasksSlice";
import TaskEditPopup from "../../../../components/ActivityList/TaskEditPopup/TaskEditPopup";
import commentIcon from "../../../../assets/images/commentIcon.svg";
import AddComment from "../../../../components/ActivityList/AddComment/AddComment";
import {
  CreateComment,
  DeleteComment,
  DeleteTask,
  EditComment,
} from "../../Nurture/service/nurture.request";
import CommentListItem from "../../../../components/ActivityList/AddComment/CommentListItem";
import DeletePopup from "../../../../components/DeletePopup/DeletePopup";
import { DeleteTaskDTO } from "../../Nurture/service/types";
import TaskListItem from "../../../../components/ActivityList/TaskListItem";
import TasksList from "../../../../components/ActivityList/TasksList";
import TaskDetails from "../../../../components/TaskCreation/TaskDetails";

interface Task {
  id: number;
  title: string;
  state: string;
  date: string;
  taskType: string;
  leadName: string;
  priority: string;
}

interface TaskKanbanProps {
  tasks: Task[];
}

interface CheckedPriorities {
  priority: string;
}
interface CheckedTypes {
  type: string;
}

type Data = {
  instituteId: string;
  startDate: any;
  endDate: any;
  limit: number;
  userId?: any;
  branchId?: any;
  lanesToFetch?: {
    status: string;
    searchAfter?: string;
    // lastEvaluatedKey: string;
    // lastEvaluatedSortKey: string;
  }[];
};

export default function TasksKanban(props: any) {
  const {
    tasks,
    UpdateTaskStatus,
    tasksByAssignee,
    GetTasksBoard,
    tasksTypes,
    taskStatusUpdateSuccess,
    GetLeadListByInstituteAndContact,
    CreateTask,
    EditTask,
    taskBoardloading,
    SendRemainders,
    sendRemaindersLoading,
    sendRemaindersSuccess,
    GetTaskCount,
    taskCountLength,
    data,
    setFromTaskEdit,
    setTaskForEditing,
    setShowAddTask,
    showAddTask,
    selectedLeadData,
    updateTaskStatusSuccess,
    leadById,
    taskIdForComment,
    setTaskIdForComment,
    listView,
    fromSideDrawer,
  } = props;

  const auth = useAuthUser();
  const authUser = auth();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<any>();
  const [taskItems, setTaskItems] = useState<any>();
  const [hasMoreData, setHasMoreData] = useState<boolean>(true);
  const [isOpen, setIsOpen] = useState(false);
  const [filterStartDate, setFilterStartDate] = useState<any>(new Date());
  const [filterEndDate, setFilterEndDate] = useState<any>(null);
  const [textForReminder, setTextForReminder] = useState("");
  const [localTaskCount, setLocalTaskCount] = useState<any>(null);

  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission,
  );

  const hasAllTaskAccess = getAccessStatus(
    "TASKS",
    "ALL_OTHER_USERS'_TASK",
    userById?.rolePermission,
  );

  const hasLeadCardPermission = checkSubDomainAccess(
    "NURTURE_BOARD",
    "LEAD_CARD",
    userById?.rolePermission,
  );

  const employees = useSelector((state: any) => state.staff.staffList);

  const {
    editTaskSuccess,
    createTaskSuccess,
    deleteTaskSuccess,
    leadUpdateSuccess,
    createCommentSuccess,
    updateCommentSuccess,
    deleteCommentSuccess,
    lastCreatedComment,
    lastCreatedTaskId,
    lastCreatedTaskCategory,
    lastEditedTaskCategory,
    lastDeletedTaskCategory,
    createTaskLoading,
    createTaskError,
  } = useSelector((state: any) => state.nurture);

  const [selectedDate, setSelectedDate] = React.useState<number | null>(
    dayjs().unix() * 1000,
  );
  const [selectedTeamMember, setSelectedTeamMember] = React.useState<any>([]);
  const [draggedLead, setdraggedLead] = useState<string>("");
  const [draggedLeadTaskType, setdraggedLeadTaskType] = useState<string>("");
  const [draggedTask, setdraggedTask] = useState<any>("");
  const [dropZoneActive, setDropZoneActive] = useState<boolean>(false);
  const [highlightedTaskId, setHighlightedTaskId] = useState<string | null>(
    null,
  );

  const [draggedColumn, setdraggedColumn] = useState<string>("");

  const updateLocalTaskCount = useCallback(
    (fromStatus: string, toStatus: string) => {
      if (!localTaskCount?.data) return;

      const updatedCounts = localTaskCount.data.map((countItem: any) => {
        if (countItem.stateName === fromStatus) {
          return {
            ...countItem,
            tasksCount: Math.max(0, (countItem.tasksCount || 0) - 1),
          };
        }
        if (countItem.stateName === toStatus) {
          return {
            ...countItem,
            tasksCount: (countItem.tasksCount || 0) + 1,
          };
        }
        return countItem;
      });

      setLocalTaskCount({
        ...localTaskCount,
        data: updatedCounts,
      });
    },
    [localTaskCount],
  );

  const incrementTaskCount = useCallback(
    (status: string) => {
      if (!localTaskCount?.data) return;

      const updatedCounts = localTaskCount.data.map((countItem: any) => {
        if (countItem.stateName === status) {
          return {
            ...countItem,
            tasksCount: (countItem.tasksCount || 0) + 1,
          };
        }
        return countItem;
      });

      setLocalTaskCount({
        ...localTaskCount,
        data: updatedCounts,
      });
    },
    [localTaskCount],
  );

  const decrementTaskCount = useCallback(
    (status: string) => {
      if (!localTaskCount?.data) return;

      const updatedCounts = localTaskCount.data.map((countItem: any) => {
        if (countItem.stateName === status) {
          return {
            ...countItem,
            tasksCount: Math.max(0, (countItem.tasksCount || 0) - 1),
          };
        }
        return countItem;
      });

      setLocalTaskCount({
        ...localTaskCount,
        data: updatedCounts,
      });
    },
    [localTaskCount],
  );
  const [newDate, setNewDate] = useState<any>(dayjs());
  const [stateName, setStateName] = useState<string>("");
  const [cardType, setCardType] = useState<string>("");
  const [taskId, setTaskId] = useState<string>("");

  const filteredTasks = React.useMemo(
    () =>
      tasks && taskItems
        ? taskItems.filter((task: any) => task?.stateName !== "COMPLETED")
        : undefined,
    [tasks, taskItems],
  );

  const completedTasks = React.useMemo(
    () =>
      tasks && taskItems
        ? taskItems.find((task: any) => task.stateName === "COMPLETED")
        : undefined,
    [tasks, taskItems],
  );

  const [isDragging, setIsDragging] = useState(false);

  const isPendingState = (state: any): boolean => {
    return state !== true && state !== false;
  };

  const refreshInProgressRef = React.useRef(false);
  const refreshTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);
  const isInitialMountRef = React.useRef(true);
  const hasInitialDataLoadedRef = React.useRef(false);

  const allTasksEmpty =
    tasks &&
    filteredTasks?.every(
      (item: any) => item?.tasks?.data && item?.tasks?.data?.length === 0,
    );

  const completedTasksEmpty: boolean = completedTasks
    ? completedTasks?.tasks?.data?.length === 0
    : false;

  const handleDragStart = React.useCallback(
    (
      event: React.DragEvent<HTMLDivElement>,
      columnStatus: any,
      taskId: any,
      taskType: string,
      task: string,
    ) => {
      setdraggedLead(taskId);
      setdraggedLeadTaskType(taskType);
      setdraggedTask(task);
      event.dataTransfer.setData("columnStatus", columnStatus.toString());
      event.dataTransfer.setData("taskId", taskId.toString());
      setdraggedColumn(columnStatus);

      setIsDragging(true);
      event.currentTarget.style.zIndex = "999";
      // setDropZoneActive(true);
    },
    [setdraggedLead],
  );

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.currentTarget.classList.add(styles.dragoverColumn);
    setDropZoneActive(true);
  };

  const handleCompletedDrop = (event: React.DragEvent<HTMLDivElement>) => {
    if (draggedLeadTaskType === "DEMO") {
      navigate(`/app/Tasks/DemoTaskDetails/${draggedLead}`);
    } else {
      const draggedColumnStatus = draggedColumn;
      if (draggedColumnStatus !== "COMPLETED") {
        if (taskItems && Array.isArray(taskItems)) {
          const updatedTaskItems = taskItems.map((column: any) => {
            if (column?.tasks?.data && Array.isArray(column.tasks.data)) {
              const filteredTasks = column.tasks.data.filter(
                (task: any) => String(task.id) !== String(draggedLead),
              );

              if (column.stateName === "COMPLETED") {
                const taskToMove = taskItems
                  .find((col: any) => col.stateName === draggedColumnStatus)
                  ?.tasks?.data?.find(
                    (t: any) => String(t.id) === String(draggedLead),
                  );

                if (taskToMove) {
                  return {
                    ...column,
                    tasks: {
                      ...column.tasks,
                      data: [
                        ...column.tasks.data,
                        {
                          ...taskToMove,
                          status: "COMPLETED",
                          taskCompletedDate: Date.now(),
                        },
                      ],
                    },
                  };
                }
              }

              return {
                ...column,
                tasks: {
                  ...column.tasks,
                  data: filteredTasks,
                },
              };
            }
            return column;
          });
          setTaskItems(updatedTaskItems);

          updateLocalTaskCount(draggedColumnStatus, "COMPLETED");
        }

        UpdateTaskStatus({
          taskId: draggedLead,
          taskStatus: "COMPLETED",
          updatedById: authUser?.institute?.[0]?.id,
          updatedByName: authUser?.firstName + " " + authUser?.lastName,
          taskType: draggedLeadTaskType,
          instituteId: authUser?.institute?.[0]?.instituteId,
        });
      }
    }
    setDropZoneActive(false);
    event.currentTarget.classList.remove(styles.dragoverColumn);
    setIsDragging(false);
    setdraggedColumn("");
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.currentTarget.classList.remove(styles.dragoverColumn);
    setIsDragging(false);
    setDropZoneActive(false);
  };

  const handleDrop = (
    event: React.DragEvent<HTMLDivElement>,
    columnStatus: any,
    stateName: any,
  ) => {
    const draggedColumnStatus = draggedColumn;

    stateName = stateName.toUpperCase().replace(" ", "_");
    setDropZoneActive(false);

    if (draggedColumnStatus !== columnStatus) {
      if (taskItems && Array.isArray(taskItems)) {
        const updatedTaskItems = taskItems.map((column: any) => {
          if (column?.tasks?.data && Array.isArray(column.tasks.data)) {
            const filteredTasks = column.tasks.data.filter(
              (task: any) => String(task.id) !== String(draggedLead),
            );

            if (column.stateName === stateName || column.status === stateName) {
              const sourceColumn = taskItems.find(
                (col: any) =>
                  col.stateName === draggedColumnStatus ||
                  col.status === draggedColumnStatus,
              );
              const taskToMove = sourceColumn?.tasks?.data?.find(
                (t: any) => String(t.id) === String(draggedLead),
              );

              if (taskToMove) {
                const updatedTask = { ...taskToMove, status: stateName };
                if (stateName === "COMPLETED") {
                  updatedTask.taskCompletedDate = Date.now();
                }
                return {
                  ...column,
                  tasks: {
                    ...column.tasks,
                    data: [...column.tasks.data, updatedTask],
                  },
                };
              }
            }

            return {
              ...column,
              tasks: {
                ...column.tasks,
                data: filteredTasks,
              },
            };
          }
          return column;
        });
        setTaskItems(updatedTaskItems);

        updateLocalTaskCount(draggedColumnStatus, stateName);
      }

      if (draggedLeadTaskType === "DEMO") {
        const demoStudentUpdate = draggedTask?.demoData?.map((item: any) => {
          return {
            demoStudentId: item.id,
            status: item?.status,
          };
        });
        UpdateTaskStatus({
          taskId: draggedLead,
          taskStatus: stateName,
          updatedById: authUser?.institute?.[0]?.id,
          updatedByName: authUser?.firstName + " " + authUser?.lastName,
          taskType: draggedLeadTaskType,
          instituteId: authUser?.institute?.[0]?.instituteId,
          demoStudentUpdate: demoStudentUpdate,
        });
      } else {
        UpdateTaskStatus({
          taskId: draggedLead,
          taskStatus: stateName,
          updatedById: authUser?.institute?.[0]?.id,
          updatedByName: authUser?.firstName + " " + authUser?.lastName,
          taskType: draggedLeadTaskType,
          instituteId: authUser?.institute?.[0]?.instituteId,
        });
      }
    }

    event.currentTarget.classList.remove(styles.dragoverColumn);
    setIsDragging(false);
    setdraggedColumn("");
  };

  const getInitialSearchTerm = () => {
    return "";
  };

  const [leadSearchTerm, setLeadSearchTerm] = React.useState(
    getInitialSearchTerm(),
  );
  const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState("");

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams.has("taskLeadSearch")) {
      urlSearchParams.delete("taskLeadSearch");
      const newUrl = `${window.location.pathname}${urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : ""}`;
      window.history.replaceState({}, "", newUrl);
      setLeadSearchTerm("");
    }
  }, []);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(leadSearchTerm);
    }, 400);

    return () => {
      clearTimeout(handler);
    };
  }, [leadSearchTerm]);

  const handleLeadSearch = (event: any) => {
    setLeadSearchTerm(event.target.value);
  };

  function getFormattedDate(date: any, taskCategory?: string) {
    if (taskCategory?.toUpperCase() === "GENERAL_TASK") {
      return moment(date).tz("Asia/Kolkata").format("DD MMM YYYY, hh:mm A");
    }
    return moment(date).format("DD MMM YYYY, hh:mm A");
  }

  const [filterCheckedPriorities, setFilterCheckedPriorities] = useState<
    CheckedPriorities[]
  >([]);

  const [filterCheckedTypes, setFilterCheckedTypes] = useState<CheckedTypes[]>(
    [],
  );

  interface CheckedCategories {
    category: string;
  }

  const [filterCheckedCategories, setFilterCheckedCategories] = useState<
    CheckedCategories[]
  >([]);

  const [filtersInitialized, setFiltersInitialized] = useState(false);

  const filteredValue = (
    <>
      {filterCheckedPriorities?.length > 0 &&
        filterCheckedPriorities?.map((item) => (
          <div key={item.priority} className="filteredDiv">
            {item.priority.toLowerCase()}
          </div>
        ))}

      {filterCheckedTypes?.length > 0 &&
        filterCheckedTypes?.map((item) => (
          <div key={item.type} className="filteredDiv">
            {item.type?.toLowerCase()}
          </div>
        ))}
    </>
  );

  const handleFilterTasks = React.useCallback(
    (
      prioritiesArray: any,
      typesArray: any,
      filterStartDates: any,
      filterEndDates: any,
      categoryArray?: any,
    ) => {
      setFilterCheckedPriorities(prioritiesArray);
      setFilterCheckedTypes(typesArray);
      setFilterCheckedCategories(categoryArray || []);
      const urlSearchParams = new URLSearchParams(window.location.search);

      const taskStartDate = urlSearchParams.get("taskStartDate");
      const taskEndDate = urlSearchParams.get("taskEndDate");
      const selectedUsersParam = urlSearchParams.get("selectedUsers");
      const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

      let selectedDateFirstMinuteForFilter = 0;
      let selectedDateLastMinuteForFilter = 0;

      if (filterStartDates !== null && filterEndDates !== null) {
        selectedDateFirstMinuteForFilter =
          moment(filterStartDates).startOf("day").unix() * 1000;
        selectedDateLastMinuteForFilter =
          moment(filterEndDates).endOf("day").unix() * 1000;
      }

      const formattedCategoryArray =
        categoryArray?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [];

      const currentSearchText = taskLeadSearchInUrl || leadSearchTerm || "";

      if (rangeStartDate && authUser && authUser.institute) {
        if (taskStartDate && taskEndDate) {
          taskBoardApiCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            currentSearchText,
            prioritiesArray,
            typesArray,
            selectedDateFirstMinuteForFilter,
            selectedDateLastMinuteForFilter,
            formattedCategoryArray,
          );
          taskCountCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            currentSearchText,
            prioritiesArray,
            typesArray,
            selectedDateFirstMinuteForFilter,
            selectedDateLastMinuteForFilter,
            formattedCategoryArray,
          );
        } else {
          const selectedDateFirstMinute =
            moment(rangeStartDate).startOf("day").unix() * 1000;

          const selectedDateLastMinute =
            moment(rangeStartDate).endOf("day").unix() * 1000;
          taskBoardApiCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            currentSearchText,
            prioritiesArray,
            typesArray,
            selectedDateFirstMinuteForFilter,
            selectedDateLastMinuteForFilter,
            formattedCategoryArray,
          );
          taskCountCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            currentSearchText,
            prioritiesArray,
            typesArray,
            selectedDateFirstMinuteForFilter,
            selectedDateLastMinuteForFilter,
            formattedCategoryArray,
          );
        }
      }

      const queryParams = new URLSearchParams(window.location.search);
      if (prioritiesArray && prioritiesArray.length > 0) {
        const priorityParam = prioritiesArray
          .map((item: any) => item.priority)
          .join("|");
        queryParams.set("taskPriorities", priorityParam);
      } else {
        queryParams.delete("taskPriorities");
      }

      if (typesArray && typesArray.length > 0) {
        const statusParam = typesArray.map((item: any) => item.type).join("|");
        queryParams.set("taskTypes", statusParam);
      } else {
        queryParams.delete("taskTypes");
      }

      if (categoryArray && categoryArray.length > 0) {
        const categoryParam = categoryArray
          .map((item: any) => item.category)
          .join("|");
        queryParams.set("taskCategories", categoryParam);
      } else {
        queryParams.delete("taskCategories");
      }

      if (filterStartDates !== null && filterEndDates !== null) {
        queryParams.set(
          "taskFilterStartDate",
          selectedDateFirstMinuteForFilter.toString(),
        );
        queryParams.set(
          "taskFilterEndDate",
          selectedDateLastMinuteForFilter.toString(),
        );
      } else {
        queryParams.delete("taskFilterStartDate");
        queryParams.delete("taskFilterEndDate");
      }

      if (currentSearchText) {
        queryParams.set("taskLeadSearch", currentSearchText);
      }

      const queryString = queryParams.toString();
      navigate(
        {
          pathname: location.pathname,
          search: queryString ? `?${queryString}` : "",
        },
        { replace: false },
      );
    },
    [
      setFilterCheckedPriorities,
      setFilterCheckedTypes,
      setFilterStartDate,
      setFilterEndDate,
      leadSearchTerm,
      navigate,
      location.pathname,
    ],
  );

  const isTriggered = useSelector(
    (state: any) => state.taskBoardUpdation?.isTriggered,
  );
  const { taskUpdateNotify } = useSelector(
    (state: any) => state.websocketNotifications,
  );
  const { taskPriorityUpdateSuccess, taskAssigneeUpdateSuccess } = useSelector(
    (state: any) => state.tasks,
  );

  const taskBoardApiCall = useCallback(
    (
      instituteId: string,
      taskStartDate: any,
      taskEndDate: any,
      userId: any,
      searchText?: any,
      prioritiesArray?: any,
      typeArray?: any,
      startDateForFilter?: any,
      endDateForFilter?: any,
      categoryArray?: any,
    ) => {
      const data: any = {
        instituteId: instituteId,
        startDate: taskStartDate,
        endDate: taskEndDate,
        getTasks: true,
        entityName: "TASK",
        priority: prioritiesArray,
        taskType: typeArray,
        searchText: searchText ? searchText : "",
        lanesToFetch: [
          {
            status: "TO_DO",
          },
          {
            status: "IN_PROGRESS",
          },
          {
            status: "BLOCKED",
          },
          {
            status: "COMPLETED",
          },
        ],
        filterStartDate: startDateForFilter ? startDateForFilter : 0,
        filterEndDate: endDateForFilter ? endDateForFilter : 0,
      };

      if (categoryArray && categoryArray.length > 0) {
        data.taskCategory = categoryArray;
      }

      if (!hasAllBranchAccess) {
        data.branchId = authUser?.institute?.[0]?.branchId;
      }

      if (hasAllTaskAccess && userId !== "") {
        data.userId = userId;
      } else if (!hasAllTaskAccess) {
        data.userId = authUser?.institute?.[0]?.id;
      }
      GetTasksBoard(data);
    },
    [userById, hasAllTaskAccess],
  );

  const taskCountCall = useCallback(
    (
      instituteId: string,
      taskStartDate: any,
      taskEndDate: any,
      userId: any,
      searchText?: any,
      prioritiesArray?: any,
      typeArray?: any,
      startDateForFilter?: any,
      endDateForFilter?: any,
      categoryArray?: any,
    ) => {
      const data: any = {
        instituteId: instituteId,
        startDate: taskStartDate,
        endDate: taskEndDate,
        getTasksCount: true,
        entityName: "TASK",
        priority: prioritiesArray,
        taskType: typeArray,
        searchText: searchText ? searchText : "",
        lanesToFetch: [
          {
            status: "TO_DO",
          },
          {
            status: "IN_PROGRESS",
          },
          {
            status: "BLOCKED",
          },
          {
            status: "COMPLETED",
          },
        ],
        filterStartDate: startDateForFilter ? startDateForFilter : 0,
        filterEndDate: endDateForFilter ? endDateForFilter : 0,
      };

      if (categoryArray && categoryArray.length > 0) {
        data.taskCategory = categoryArray;
      }

      if (!hasAllBranchAccess) {
        data.branchId = authUser?.institute?.[0]?.branchId;
      }

      if (hasAllTaskAccess && userId !== "") {
        data.userId = userId;
      } else if (!hasAllTaskAccess) {
        data.userId = authUser?.institute?.[0]?.id;
      }
      GetTaskCount(data);
    },
    [userById, hasAllTaskAccess],
  );

  const [rangeStartDate, setRangeStartDate] = useState<any>(new Date());
  const [rangeEndDate, setRangeEndDate] = useState<any>(null);

  const refreshTaskBoard = React.useCallback(
    (delay: number = 350, isGeneralTaskOperation: boolean = false) => {
      if (refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current);
      }

      if (refreshInProgressRef.current) {
        refreshTimeoutRef.current = setTimeout(() => {
          refreshTaskBoard(delay, isGeneralTaskOperation);
        }, delay);
        return;
      }

      refreshInProgressRef.current = true;

      refreshTimeoutRef.current = setTimeout(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const taskStartDate = urlSearchParams.get("taskStartDate");
        const taskEndDate = urlSearchParams.get("taskEndDate");
        const selectedUsersParam = urlSearchParams.get("selectedUsers");
        const taskFilterStartDate = urlSearchParams.get("taskFilterStartDate");
        const taskFilterEndDate = urlSearchParams.get("taskFilterEndDate");
        const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

        if (rangeStartDate && authUser && authUser.institute) {
          let formattedCategories =
            filterCheckedCategories?.map((item: any) => ({
              taskCategory: formatTaskCategory(item.category),
            })) || [];

          if (isGeneralTaskOperation && formattedCategories.length > 0) {
            const hasGeneralTask = formattedCategories.some(
              (c: any) =>
                c.taskCategory === "GENERAL_TASK" ||
                c.taskCategory === "General Task",
            );
            if (!hasGeneralTask) {
              formattedCategories = [
                ...formattedCategories,
                { taskCategory: "GENERAL_TASK" },
              ];
            }
          }

          const currentSearchText = taskLeadSearchInUrl || leadSearchTerm || "";

          const makeApiCalls = () => {
            if (taskStartDate && taskEndDate) {
              taskBoardApiCall(
                authUser?.institute?.[0]?.instituteDetails?.id,
                taskStartDate,
                taskEndDate,
                selectedUsersParam
                  ? selectedUsersParam.split(",").filter(Boolean)
                  : "",
                currentSearchText,
                filterCheckedPriorities,
                filterCheckedTypes,
                Number(taskFilterStartDate),
                Number(taskFilterEndDate),
                formattedCategories,
              );
              taskCountCall(
                authUser?.institute?.[0]?.instituteDetails?.id,
                taskStartDate,
                taskEndDate,
                selectedUsersParam
                  ? selectedUsersParam.split(",").filter(Boolean)
                  : "",
                currentSearchText,
                filterCheckedPriorities,
                filterCheckedTypes,
                Number(taskFilterStartDate),
                Number(taskFilterEndDate),
                formattedCategories,
              );
            } else {
              const selectedDateFirstMinute =
                moment(rangeStartDate).startOf("day").unix() * 1000;
              const selectedDateLastMinute =
                moment(rangeStartDate).endOf("day").unix() * 1000;

              taskBoardApiCall(
                authUser?.institute?.[0]?.instituteDetails?.id,
                selectedDateFirstMinute,
                selectedDateLastMinute,
                selectedUsersParam
                  ? selectedUsersParam.split(",").filter(Boolean)
                  : "",
                currentSearchText,
                filterCheckedPriorities,
                filterCheckedTypes,
                Number(taskFilterStartDate),
                Number(taskFilterEndDate),
                formattedCategories,
              );
              taskCountCall(
                authUser?.institute?.[0]?.instituteDetails?.id,
                selectedDateFirstMinute,
                selectedDateLastMinute,
                selectedUsersParam
                  ? selectedUsersParam.split(",").filter(Boolean)
                  : "",
                currentSearchText,
                filterCheckedPriorities,
                filterCheckedTypes,
                Number(taskFilterStartDate),
                Number(taskFilterEndDate),
                formattedCategories,
              );
            }
          };

          makeApiCalls();
        }

        refreshInProgressRef.current = false;
      }, delay);
    },
    [
      rangeStartDate,
      authUser,
      filterCheckedCategories,
      leadSearchTerm,
      filterCheckedPriorities,
      filterCheckedTypes,
      taskBoardApiCall,
      taskCountCall,
    ],
  );

  const onDateChange = (dates: any) => {
    const [start, end] = dates;
    setRangeStartDate(start);
    setRangeEndDate(end);
    const selectedDateFirstMinute = moment(start).startOf("day").unix() * 1000;
    const selectedStartDateLastMinute =
      moment(start).endOf("day").unix() * 1000;

    const selectedDateLastMinute = moment(end).endOf("day").unix() * 1000;

    const queryParams = new URLSearchParams(window.location.search);

    const taskFilterStartDate = queryParams.get("taskFilterStartDate");
    const taskFilterEndDate = queryParams.get("taskFilterEndDate");
    const taskLeadSearchInUrl = queryParams.get("taskLeadSearch");

    const currentSearchText = taskLeadSearchInUrl || leadSearchTerm || "";

    if (end !== null && authUser) {
      taskBoardApiCall(
        authUser?.institute?.[0]?.instituteDetails?.id,
        selectedDateFirstMinute,
        selectedDateLastMinute,
        selectedTeamMember?.length > 0
          ? selectedTeamMember.map((m: any) => String(m.id))
          : "",
        currentSearchText,
        filterCheckedPriorities,
        filterCheckedTypes,
        Number(taskFilterStartDate) || 0,
        Number(taskFilterEndDate) || 0,
        filterCheckedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [],
      );
      taskCountCall(
        authUser?.institute?.[0]?.instituteDetails?.id,
        selectedDateFirstMinute,
        selectedDateLastMinute,
        selectedTeamMember?.length > 0
          ? selectedTeamMember.map((m: any) => String(m.id))
          : "",
        currentSearchText,
        filterCheckedPriorities,
        filterCheckedTypes,
        Number(taskFilterStartDate) || 0,
        Number(taskFilterEndDate) || 0,
        filterCheckedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [],
      );
      queryParams.set("taskStartDate", selectedDateFirstMinute.toString());
      queryParams.set("taskEndDate", selectedDateLastMinute.toString());

      navigate(
        {
          pathname: location.pathname,
          search: queryParams.toString() ? `?${queryParams.toString()}` : "",
        },
        { replace: false },
      );
    } else {
      taskBoardApiCall(
        authUser?.institute?.[0]?.instituteDetails?.id,
        selectedDateFirstMinute,
        selectedStartDateLastMinute,
        selectedTeamMember?.length > 0
          ? selectedTeamMember.map((m: any) => String(m.id))
          : "",
        currentSearchText,
        filterCheckedPriorities,
        filterCheckedTypes,
        Number(taskFilterStartDate) || 0,
        Number(taskFilterEndDate) || 0,
        filterCheckedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [],
      );
      taskCountCall(
        authUser?.institute?.[0]?.instituteDetails?.id,
        selectedDateFirstMinute,
        selectedStartDateLastMinute,
        selectedTeamMember?.length > 0
          ? selectedTeamMember.map((m: any) => String(m.id))
          : "",
        currentSearchText,
        filterCheckedPriorities,
        filterCheckedTypes,
        Number(taskFilterStartDate) || 0,
        Number(taskFilterEndDate) || 0,
        filterCheckedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [],
      );
      queryParams.set("taskStartDate", selectedDateFirstMinute.toString());
      queryParams.set("taskEndDate", selectedStartDateLastMinute.toString());

      navigate(
        {
          pathname: location.pathname,
          search: queryParams.toString() ? `?${queryParams.toString()}` : "",
        },
        { replace: false },
      );
    }
  };

  const onFilterDateChange = (dates: any) => {
    const [start, end] = dates;
    setFilterStartDate(start);
    setFilterEndDate(end);
  };

  React.useEffect(() => {
    if (debouncedSearchTerm === leadSearchTerm && filtersInitialized) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const taskStartDate = urlSearchParams.get("taskStartDate");
      const taskEndDate = urlSearchParams.get("taskEndDate");
      const selectedUsersParam = urlSearchParams.get("selectedUsers");
      const taskFilterStartDate = urlSearchParams.get("taskFilterStartDate");
      const taskFilterEndDate = urlSearchParams.get("taskFilterEndDate");

      if (rangeStartDate && authUser && authUser.institute) {
        const userIds = selectedUsersParam
          ? selectedUsersParam.split(",").filter(Boolean)
          : "";

        if (taskStartDate && taskEndDate) {
          taskBoardApiCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            userIds,
            debouncedSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            Number(taskFilterStartDate) || 0,
            Number(taskFilterEndDate) || 0,
            filterCheckedCategories?.map((item: any) => ({
              taskCategory: formatTaskCategory(item.category),
            })) || [],
          );
          taskCountCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            userIds,
            debouncedSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            Number(taskFilterStartDate) || 0,
            Number(taskFilterEndDate) || 0,
            filterCheckedCategories?.map((item: any) => ({
              taskCategory: formatTaskCategory(item.category),
            })) || [],
          );
        } else {
          const selectedDateFirstMinute =
            moment(rangeStartDate).startOf("day").unix() * 1000;

          const selectedDateLastMinute =
            moment(rangeStartDate).endOf("day").unix() * 1000;

          taskBoardApiCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            userIds,
            debouncedSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            Number(taskFilterStartDate) || 0,
            Number(taskFilterEndDate) || 0,
            filterCheckedCategories?.map((item: any) => ({
              taskCategory: formatTaskCategory(item.category),
            })) || [],
          );
          taskCountCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            userIds,
            debouncedSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            Number(taskFilterStartDate) || 0,
            Number(taskFilterEndDate) || 0,
            filterCheckedCategories?.map((item: any) => ({
              taskCategory: formatTaskCategory(item.category),
            })) || [],
          );
        }
      }
      const queryParams = new URLSearchParams(window.location.search);
      if (debouncedSearchTerm) {
        queryParams.set("taskLeadSearch", debouncedSearchTerm);
      } else {
        queryParams.delete("taskLeadSearch");
      }
      navigate(
        {
          pathname: location.pathname,
          search: queryParams.toString() ? `?${queryParams.toString()}` : "",
        },
        { replace: false },
      );
    }
  }, [debouncedSearchTerm, filtersInitialized, navigate, location.pathname]);

  const handleResetDate = useCallback(() => {
    setSelectedDate(dayjs().unix() * 1000);
    setNewDate(dayjs());
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete("taskDate");
    queryParams.delete("taskStartDate");
    queryParams.delete("taskEndDate");

    const taskFilterStartDate = queryParams.get("taskFilterStartDate");
    const taskFilterEndDate = queryParams.get("taskFilterEndDate");
    const taskLeadSearchInUrl = queryParams.get("taskLeadSearch");

    navigate(
      {
        pathname: location.pathname,
        search: queryParams.toString() ? `?${queryParams.toString()}` : "",
      },
      { replace: false },
    );

    setRangeStartDate(new Date());
    setRangeEndDate(new Date());

    const selectedDateFirstMinute = moment().startOf("day").unix() * 1000;
    const selectedDateLastMinute = moment().endOf("day").unix() * 1000;

    const currentSearchText = taskLeadSearchInUrl || leadSearchTerm || "";

    taskBoardApiCall(
      authUser?.institute?.[0]?.instituteDetails?.id,
      selectedDateFirstMinute,
      selectedDateLastMinute,
      selectedTeamMember?.length > 0
        ? selectedTeamMember.map((m: any) => String(m.id))
        : "",
      currentSearchText,
      filterCheckedPriorities,
      filterCheckedTypes,
      Number(taskFilterStartDate) || 0,
      Number(taskFilterEndDate) || 0,
      filterCheckedCategories?.map((item: any) => ({
        taskCategory: formatTaskCategory(item.category),
      })) || [],
    );
    taskCountCall(
      authUser?.institute?.[0]?.instituteDetails?.id,
      selectedDateFirstMinute,
      selectedDateLastMinute,
      selectedTeamMember?.length > 0
        ? selectedTeamMember.map((m: any) => String(m.id))
        : "",
      currentSearchText,
      filterCheckedPriorities,
      filterCheckedTypes,
      Number(taskFilterStartDate) || 0,
      Number(taskFilterEndDate) || 0,
      filterCheckedCategories?.map((item: any) => ({
        taskCategory: formatTaskCategory(item.category),
      })) || [],
    );
  }, [
    setSelectedDate,
    setRangeStartDate,
    setRangeEndDate,
    selectedTeamMember,
    filterCheckedPriorities,
    filterCheckedTypes,
    filterCheckedCategories,
    taskBoardApiCall,
    taskCountCall,
    authUser,
    leadSearchTerm,
    navigate,
    location.pathname,
  ]);

  const handleNextPage = (currentLaneStatus: any) => {
    const userFromLocalStorage = authUser?.institute?.[0]?.instituteDetails;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskFilterStartDate = urlSearchParams.get("taskFilterStartDate");
    const taskFilterEndDate = urlSearchParams.get("taskFilterEndDate");
    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("taskTypes");
    const categoryParam = urlSearchParams.get("taskCategories");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

    let startingDate = null;
    let endingDate = null;
    if (taskStartDate && taskStartDate !== null && taskEndDate !== null) {
      startingDate = taskStartDate;
      endingDate = taskEndDate;
    } else {
      startingDate = moment(rangeStartDate).startOf("day").unix() * 1000;

      endingDate = moment(rangeStartDate).endOf("day").unix() * 1000;
    }

    let selectedPriorities: any[] = [];
    if (priorityParam) {
      const priorities = priorityParam.split("|");
      selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase(),
          );
          return priority ? { priority: priority.priority } : null;
        })
        .filter(Boolean);
    }

    let selectedTypes: any[] = [];
    if (typeParam && tasksTypes) {
      const types = typeParam.split("|");
      selectedTypes = types
        .map((value) => {
          const type = tasksTypes?.find(
            (taskType: any) =>
              taskType.taskTypeName.toLowerCase() === value.toLowerCase(),
          );
          return type ? { type: type.taskTypeName } : null;
        })
        .filter(Boolean);
    }

    let selectedCategories: any[] = [];
    if (categoryParam) {
      const categories = categoryParam.split("|");
      selectedCategories = categories
        .map((value) => {
          const category = [
            { category: "Student Task" },
            { category: "General Task" },
            { category: "Payment Overdue Task" },
          ].find(
            (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
          );
          return category ? { category: category.category } : null;
        })
        .filter(Boolean);
    }

    const formattedCategories =
      selectedCategories?.map((item: any) => ({
        taskCategory: formatTaskCategory(item.category),
      })) || [];

    const evaluatedKeysForLanes: any =
      taskItems &&
      taskItems
        ?.filter((d: any) => d?.stateName === currentLaneStatus)
        ?.map((d: any) => {
          return {
            status: currentLaneStatus,
            searchAfter: d?.tasks?.searchAfter,
          };
        });

    const data: any = {
      instituteId: userFromLocalStorage?.id,
      startDate: startingDate,
      endDate: endingDate,
      lanesToFetch: evaluatedKeysForLanes,
      getTasks: true,
      entityName: "TASK",
      priority: selectedPriorities,
      taskType: selectedTypes,
      searchText: taskLeadSearchInUrl ? taskLeadSearchInUrl : "",
      filterStartDate: taskFilterStartDate ? Number(taskFilterStartDate) : 0,
      filterEndDate: taskFilterEndDate ? Number(taskFilterEndDate) : 0,
    };

    if (formattedCategories && formattedCategories.length > 0) {
      data.taskCategory = formattedCategories;
    }

    if (!hasAllBranchAccess) {
      data.branchId = authUser?.institute?.[0]?.branchId;
    }

    if (hasAllTaskAccess && selectedUsersParam) {
      data.userId = selectedUsersParam.split(",").filter(Boolean);
    } else if (!hasAllTaskAccess) {
      data.userId = authUser?.institute?.[0]?.id;
    }

    GetTaskBoard(data).then((res: any) => {
      const result = res?.data?.data;
      const updatedState = taskItems?.map((oldObject: any) => {
        const correspondingResult = result?.find(
          (r: any) => r.stateName === oldObject.stateName,
        );

        if (correspondingResult) {
          const updatedTasks = [...oldObject.tasks?.data];

          correspondingResult?.tasks?.data?.forEach((newTask: any) => {
            if (!updatedTasks?.find((task) => task.id === newTask.id)) {
              updatedTasks.push(newTask);
            }
          });

          return {
            ...oldObject,
            tasks: {
              data: updatedTasks,
              hasMore: correspondingResult?.tasks?.hasMore,
              searchAfter: correspondingResult?.tasks?.searchAfter,
            },
          };
        } else {
          return oldObject;
        }
      });
      setTaskItems(updatedState);
    });
  };

  useEffect(() => {
    if (tasks) {
      setTaskItems(tasks);

      if (lastCreatedTaskId && (createTaskSuccess || editTaskSuccess)) {
        const taskExists = tasks?.some((column: any) =>
          column?.tasks?.data?.some(
            (task: any) =>
              String(task.id) === String(lastCreatedTaskId) ||
              String(task.activityId) === String(lastCreatedTaskId),
          ),
        );

        if (taskExists && !highlightedTaskId) {
          setHighlightedTaskId(lastCreatedTaskId);

          setTimeout(() => {
            const taskElement = document.getElementById(
              `task-${lastCreatedTaskId}`,
            );
            if (taskElement) {
              taskElement.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }
          }, 300);

          setTimeout(() => {
            setHighlightedTaskId(null);
          }, 5000);
        }
      }
    } else {
      setTaskItems([]);
    }
  }, [
    tasks,
    lastCreatedTaskId,
    createTaskSuccess,
    editTaskSuccess,
    highlightedTaskId,
  ]);

  useEffect(() => {
    if (taskCountLength) {
      setLocalTaskCount(taskCountLength);

      if (optimisticUpdateRef.current?.applied) {
        optimisticUpdateRef.current = null;
      }
    }
  }, [taskCountLength]);

  useEffect(() => {
    return () => {
      if (refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current);
      }
    };
  }, []);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskDate = urlSearchParams.get("taskDate");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");

    if (!isInitialMountRef.current) {
      const urlSearchValue = taskLeadSearchInUrl || "";
      setLeadSearchTerm(urlSearchValue);
    } else {
      isInitialMountRef.current = false;
    }

    if (taskDate && taskDate !== null) {
      setSelectedDate(parseInt(taskDate));
    }

    if (taskStartDate && taskStartDate !== null && taskEndDate !== null) {
      const startDate = new Date(parseInt(taskStartDate));
      const endDate = new Date(parseInt(taskEndDate));
      setRangeStartDate(startDate);
      setRangeEndDate(endDate);
    }
  }, [location.search]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskFilterStartDate: any = urlSearchParams.get("taskFilterStartDate");
    const taskFilterEndDate: any = urlSearchParams.get("taskFilterEndDate");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("taskTypes");
    const categoryParam = urlSearchParams.get("taskCategories");

    let selectedPriorities: CheckedPriorities[] = [];
    let selectedTypes: CheckedTypes[] = [];
    let selectedCategories: CheckedCategories[] = [];

    if (priorityParam) {
      const priorities = priorityParam.split("|");

      selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase(),
          );
          return priority
            ? {
                priority: priority.priority,
              }
            : null;
        })
        .filter(Boolean) as CheckedPriorities[];

      setFilterCheckedPriorities(selectedPriorities);
    }

    if (typeParam && tasksTypes) {
      const types = typeParam.split("|");

      selectedTypes = types
        .map((value) => {
          const type = tasksTypes?.find(
            (taskType: any) =>
              taskType.taskTypeName.toLowerCase() === value.toLowerCase(),
          );
          return type
            ? {
                type: type.taskTypeName,
              }
            : null;
        })
        .filter(Boolean) as CheckedTypes[];

      setFilterCheckedTypes(selectedTypes);
    }

    if (categoryParam) {
      const categories = categoryParam.split("|");

      selectedCategories = categories
        .map((value) => {
          const category = [
            { category: "Student Task" },
            { category: "General Task" },
            { category: "Payment Overdue Task" },
          ].find(
            (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
          );
          return category
            ? {
                category: category.category,
              }
            : null;
        })
        .filter(Boolean) as CheckedCategories[];

      setFilterCheckedCategories(selectedCategories);
    }

    if (userById) {
      const formattedCategories =
        selectedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [];

      const hasTypeFilterReady = !typeParam || tasksTypes !== undefined;
      const shouldMakeInitialCall =
        !hasInitialDataLoadedRef.current && hasTypeFilterReady;

      if (shouldMakeInitialCall) {
        let apiCallsMade = false;

        if (taskStartDate && taskStartDate !== null && taskEndDate !== null) {
          taskBoardApiCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            Number(taskFilterStartDate),
            Number(taskFilterEndDate),
            formattedCategories,
          );
          taskCountCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            Number(taskFilterStartDate),
            Number(taskFilterEndDate),
            formattedCategories,
          );
          apiCallsMade = true;
        } else if (rangeStartDate) {
          const selectedDateFirstMinute =
            moment(rangeStartDate).startOf("day").unix() * 1000;

          const selectedDateLastMinute =
            moment(rangeStartDate).endOf("day").unix() * 1000;

          taskBoardApiCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            Number(taskFilterStartDate),
            Number(taskFilterEndDate),
            formattedCategories,
          );
          taskCountCall(
            authUser?.institute?.[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            Number(taskFilterStartDate),
            Number(taskFilterEndDate),
            formattedCategories,
          );
          apiCallsMade = true;
        }

        if (apiCallsMade) {
          hasInitialDataLoadedRef.current = true;
        }
      }

      setFiltersInitialized(true);
    } else if (!priorityParam && !typeParam && !categoryParam) {
      setFiltersInitialized(true);
    }
  }, [userById, tasksTypes, location.search]);

  const { createPaymentSuccessForTask } = useSelector(
    (state: any) => state?.nurture,
  );

  const { taskById } = useSelector((state: any) => state.tasks);

  React.useEffect(() => {
    if (isPendingState(taskStatusUpdateSuccess)) {
      refreshTaskBoard(350, true);
      dispatch(resetTaskUpdateSuccess());
    }
  }, [taskStatusUpdateSuccess, refreshTaskBoard, dispatch]);

  React.useEffect(() => {
    if (isPendingState(taskPriorityUpdateSuccess)) {
      refreshTaskBoard(350, true);
      dispatch(resetTaskUpdateSuccess());
    }
  }, [taskPriorityUpdateSuccess, refreshTaskBoard, dispatch]);

  React.useEffect(() => {
    if (isPendingState(taskAssigneeUpdateSuccess)) {
      refreshTaskBoard(350, true);
      dispatch(resetTaskUpdateSuccess());
    }
  }, [taskAssigneeUpdateSuccess, refreshTaskBoard, dispatch]);

  React.useEffect(() => {
    if (isPendingState(createPaymentSuccessForTask)) {
      refreshTaskBoard(1000);
      dispatch(resetCreatePaymentSuccessForTask());
    }
  }, [createPaymentSuccessForTask, refreshTaskBoard, dispatch]);

  React.useEffect(() => {
    if (taskUpdateNotify === true) {
      refreshTaskBoard(350, true);

      const clearNotifyTimeout = setTimeout(() => {
        dispatch(clearTaskBoardRefresh());
      }, 3000);

      return () => clearTimeout(clearNotifyTimeout);
    }
  }, [taskUpdateNotify, refreshTaskBoard, dispatch]);

  const optimisticUpdateRef = React.useRef<{
    status: string;
    applied: boolean;
  } | null>(null);
  const errorProcessedRef = React.useRef<boolean>(false);
  const prevErrorRef = React.useRef<any>(createTaskError);

  React.useEffect(() => {
    if (createTaskLoading && !optimisticUpdateRef.current?.applied) {
      const taskStatus = "TO_DO";
      incrementTaskCount(taskStatus);
      optimisticUpdateRef.current = { status: taskStatus, applied: true };
      errorProcessedRef.current = false;
    }
  }, [createTaskLoading, incrementTaskCount]);

  React.useEffect(() => {
    const isNewError =
      createTaskError &&
      (!prevErrorRef.current || prevErrorRef.current !== createTaskError);

    if (
      isNewError &&
      optimisticUpdateRef.current?.applied &&
      !errorProcessedRef.current
    ) {
      const { status } = optimisticUpdateRef.current;

      decrementTaskCount(status);
      optimisticUpdateRef.current = null;
      errorProcessedRef.current = true;
    }

    if (!createTaskError && errorProcessedRef.current) {
      errorProcessedRef.current = false;
    }

    prevErrorRef.current = createTaskError;
  }, [createTaskError, decrementTaskCount]);

  React.useEffect(() => {
    if (isPendingState(createTaskSuccess) && errorProcessedRef.current) {
      errorProcessedRef.current = false;
    }
  }, [createTaskSuccess]);

  React.useEffect(() => {
    if (rangeStartDate && authUser) {
      const isEditSuccess = isPendingState(editTaskSuccess);
      const isDeleteSuccess = isPendingState(deleteTaskSuccess);
      const isCreateSuccess = isPendingState(createTaskSuccess);
      const isLeadUpdateSuccess = isPendingState(leadUpdateSuccess);

      if (
        isEditSuccess ||
        isDeleteSuccess ||
        isCreateSuccess ||
        isLeadUpdateSuccess
      ) {
        const delay = isDeleteSuccess ? 1200 : isEditSuccess ? 500 : 350;

        const isGeneralTaskOperation =
          (isCreateSuccess &&
            lastCreatedTaskCategory?.toUpperCase() === "GENERAL_TASK") ||
          (isEditSuccess &&
            lastEditedTaskCategory?.toUpperCase() === "GENERAL_TASK") ||
          (isDeleteSuccess &&
            lastDeletedTaskCategory?.toUpperCase() === "GENERAL_TASK");

        refreshTaskBoard(delay, isGeneralTaskOperation);

        if ((isCreateSuccess || isEditSuccess) && lastCreatedTaskId) {
          const highlightDelay = isGeneralTaskOperation
            ? delay + 400
            : delay + 200;

          if (isGeneralTaskOperation) {
            setSelectedGeneralTaskId(null);
            dispatch(resetTaskById());
          }

          setTimeout(() => {
            setHighlightedTaskId(lastCreatedTaskId);

            const scrollToTask = (retries = 0) => {
              let taskElement: HTMLElement | null = document.getElementById(
                `task-${lastCreatedTaskId}`,
              );

              if (!taskElement) {
                const allTaskElements =
                  document.querySelectorAll('[id^="task-"]');

                Array.from(allTaskElements).forEach((element) => {
                  if (!taskElement) {
                    const elementId = element.getAttribute("id");
                    if (
                      elementId &&
                      (elementId === `task-${lastCreatedTaskId}` ||
                        elementId.includes(String(lastCreatedTaskId)))
                    ) {
                      taskElement = element as HTMLElement;
                    }
                  }
                });
              }

              if (taskElement) {
                const elementToScroll = taskElement;
                elementToScroll.scrollIntoView({
                  behavior: "auto",
                  block: "nearest",
                  inline: "nearest",
                });

                setTimeout(() => {
                  const scrollableParent = elementToScroll.closest(
                    '[class*="kanbanBoardLeadsWrap"]',
                  );

                  if (scrollableParent) {
                    const elementRect = elementToScroll.getBoundingClientRect();
                    const parentRect = scrollableParent.getBoundingClientRect();
                    const scrollTop = scrollableParent.scrollTop;

                    const elementCenter =
                      elementRect.top + elementRect.height / 2;
                    const parentCenter = parentRect.top + parentRect.height / 2;
                    const offset = elementCenter - parentCenter;
                    const targetScrollTop = scrollTop + offset;

                    scrollableParent.scrollTo({
                      top: Math.max(0, targetScrollTop),
                      behavior: "smooth",
                    });
                  } else {
                    elementToScroll.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "nearest",
                    });
                  }
                }, 100);
              } else if (retries < 10) {
                setTimeout(() => scrollToTask(retries + 1), 400);
              }
            };

            setTimeout(() => scrollToTask(), 500);

            setTimeout(() => {
              setHighlightedTaskId(null);
            }, 5000);
          }, highlightDelay);
        }

        setTimeout(
          () => {
            if (isEditSuccess) {
              dispatch(resetEditTaskSuccess());
            }
            if (isDeleteSuccess) {
              dispatch(resetDeleteTaskSuccess());
            }
            if (isCreateSuccess) {
              dispatch(resetTaskSuccess());
            }
          },
          delay + (isDeleteSuccess ? 1000 : 500),
        );
      }
    }
  }, [
    createTaskSuccess,
    editTaskSuccess,
    deleteTaskSuccess,
    leadUpdateSuccess,
    rangeStartDate,
    authUser,
    refreshTaskBoard,
    dispatch,
    lastCreatedTaskId,
    lastCreatedTaskCategory,
    lastEditedTaskCategory,
    lastDeletedTaskCategory,
  ]);

  React.useEffect(() => {
    if (rangeStartDate && authUser) {
      const isDeleteSuccess = isPendingState(deleteCommentSuccess);
      const isCreateOrUpdateSuccess =
        isPendingState(createCommentSuccess) ||
        isPendingState(updateCommentSuccess);

      if (isDeleteSuccess || isCreateOrUpdateSuccess) {
        const delay = isDeleteSuccess ? 1500 : 2000;

        const isGeneralTaskComment =
          lastCreatedComment?.isGeneralTaskComment || false;

        const hasGeneralTaskInFilter =
          filterCheckedCategories.length === 0 ||
          filterCheckedCategories.some(
            (cat: any) =>
              cat.category === "General Task" ||
              cat.category === "GENERAL_TASK",
          );

        refreshTaskBoard(delay, isGeneralTaskComment || hasGeneralTaskInFilter);

        setTimeout(
          () => {
            dispatch(resetCommentStatuses());
          },
          delay + (isDeleteSuccess ? 500 : 0),
        );
      }
    }
  }, [
    createCommentSuccess,
    updateCommentSuccess,
    deleteCommentSuccess,
    rangeStartDate,
    authUser,
    refreshTaskBoard,
    dispatch,
    lastCreatedComment,
    filterCheckedCategories,
  ]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    // if (employees?.length > 0) {
    //   const staff = employees
    //     ?.filter((item: any) => item?.status === "ACTIVE")
    //     ?.find((item: any) => item.id === selectedUsersParam);
    //   if (staff) {
    //     setSelectedTeamMember([staff]);
    //   } else {
    //     setSelectedTeamMember([]);
    //   }
    // }

    const selectedUserIds: string[] = selectedUsersParam
      ? selectedUsersParam.split(",").filter(Boolean)
      : [];

    if (selectedUserIds.length > 0 && employees) {
      const preselectedMembers = employees.filter((member: any) =>
        selectedUserIds.includes(String(member.id)),
      );
      setSelectedTeamMember(preselectedMembers);
    } else if (selectedUserIds.length === 0) {
      setSelectedTeamMember([]);
    }
  }, [employees, location.search]);

  React.useEffect(() => {
    if (Array.isArray(taskItems)) {
      const evaluatedKeysForLanes = taskItems?.map((d) => {
        return {
          status: d?.status,
          lastEvaluatedKey: d?.lastEvaluatedKey ? d?.lastEvaluatedKey : "",
          lastEvaluatedSortKey: d?.lastEvaluatedSortKey
            ? d?.lastEvaluatedSortKey
            : "",
        };
      });

      const hasEvaluatedKey = evaluatedKeysForLanes.some(
        (ds) => ds.lastEvaluatedKey !== "",
      );

      setHasMoreData(hasEvaluatedKey);
    } else {
      setHasMoreData(false);
    }
  }, [taskItems]);

  const handlePopupYesButton = () => {
    handleSendRemainders();
  };

  const handlePopupNoButton = () => {
    setIsOpen(false);
  };

  const handleSendRemainders = (id?: any, type?: string) => {
    var body;
    const userFromLocalStorage = authUser?.institute?.[0]?.instituteDetails;
    if (cardType === "GLOBAL") {
      body = {
        action: "sendReminder",
        instituteId: userFromLocalStorage?.id,
        type: "GLOBAL",
        branchId:
          userById?.roleCode === "SUPER_ADMIN"
            ? ""
            : authUser?.institute?.[0]?.branchId,
        triggeredById: authUser?.institute?.[0]?.id,
      };
    } else if (cardType === "STAGE") {
      body = {
        action: "sendReminder",
        instituteId: userFromLocalStorage?.id,
        type: "STAGE",
        branchId:
          userById?.roleCode === "SUPER_ADMIN"
            ? ""
            : authUser?.institute?.[0]?.branchId,
        stageName: stateName,
        triggeredById: authUser?.institute?.[0]?.id,
      };
    } else if (type === "CARD") {
      body = {
        action: "sendReminder",
        instituteId: userFromLocalStorage?.id,
        type: "INDIVIDUAL",
        taskId: id,
        triggeredById: authUser?.institute?.[0]?.id,
      };
    }
    SendRemainders(body);
    setCardType("");
    setStateName("");
    setTaskId("");
  };

  useEffect(() => {
    if (sendRemaindersSuccess) {
      dispatch(resetSendRemainders());
      setIsOpen(false);
    }
  }, [sendRemaindersSuccess]);

  const [selectedGeneralTaskId, setSelectedGeneralTaskId] = useState<
    string | null
  >(null);
  const lastProcessedTaskIdRef = useRef<string | null>(null);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search);
    const taskIdFromUrl = urlSearchParams.get("taskId");

    if (taskIdFromUrl && taskIdFromUrl !== lastProcessedTaskIdRef.current) {
      lastProcessedTaskIdRef.current = taskIdFromUrl;
      setSelectedGeneralTaskId(taskIdFromUrl);
      dispatch(
        getTaskById({ id: taskIdFromUrl, taskCategory: "GENERAL_TASK" }) as any,
      )
        .unwrap()
        .catch((err: { status?: number; message?: string }) => {
          if (err?.status === 404) {
            setSelectedGeneralTaskId(null);
            dispatch(resetTaskById());
            dispatch(
              setToastNotification({
                message:
                  err?.message || "Task not found. It may have been deleted.",
                type: "error",
                snackOpen: true,
              }),
            );
            refreshTaskBoard(500, true);
          }
        });

      setTimeout(() => {
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.delete("taskId");
        const newUrl = `${window.location.pathname}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
        window.history.replaceState({}, "", newUrl);
      }, 800);
    } else if (!taskIdFromUrl) {
      lastProcessedTaskIdRef.current = null;
    }
  }, [dispatch, location.search, location.pathname, refreshTaskBoard]);

  const handleClick = (task: any) => {
    if (task?.taskCategory?.toUpperCase() === "GENERAL_TASK") {
      const taskId = task.id || task.activityId;
      if (taskId) {
        setSelectedGeneralTaskId(taskId);
        dispatch(
          getTaskById({ id: taskId, taskCategory: "GENERAL_TASK" }) as any,
        )
          .unwrap()
          .catch((err: { status?: number; message?: string }) => {
            if (err?.status === 404) {
              setSelectedGeneralTaskId(null);
              dispatch(resetTaskById());
              dispatch(
                setToastNotification({
                  message:
                    err?.message || "Task not found. It may have been deleted.",
                  type: "error",
                  snackOpen: true,
                }),
              );
              refreshTaskBoard(500, true);
            }
          });
      }
    }
  };

  const handleClose = () => {
    setSelectedGeneralTaskId(null);
    dispatch(resetTaskById());
  };

  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
        display: "flex",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <Box
        className={styles.taskKanbanBoard}
        sx={{ overflowX: "hidden", minWidth: 0 }}
      >
        <TaskKanbanHeader
          handleFilterTasks={handleFilterTasks}
          handleLeadSearch={handleLeadSearch}
          leadSearchTerm={leadSearchTerm}
          tasksTypes={tasksTypes}
          filteredValue={filteredValue}
          filterCheckedPriorities={filterCheckedPriorities}
          filterCheckedTypes={filterCheckedTypes}
          filterCheckedCategories={filterCheckedCategories}
          setSelectedTeamMember={setSelectedTeamMember}
          selectedTeamMember={selectedTeamMember}
          rangeStartDate={rangeStartDate}
          taskBoardApiCall={taskBoardApiCall}
          setIsOpen={setIsOpen}
          filterStartDate={filterStartDate}
          setFilterStartDate={setFilterStartDate}
          filterEndDate={filterEndDate}
          setFilterEndDate={setFilterEndDate}
          onFilterDateChange={onFilterDateChange}
          setCardType={setCardType}
          setTextForReminder={setTextForReminder}
          taskCountCall={taskCountCall}
          CreateTask={CreateTask}
          EditTask={EditTask}
          employees={employees}
          taskTypes={tasksTypes}
          selectedLeadData={null}
        />
        <div
          style={{
            padding: "16px 11px 0px 11px",
            overflowX: "hidden",
            position: "relative",
            width: "100%",
          }}
        >
          {tasks && allTasksEmpty === true && draggedColumn === "" ? (
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#667085",
                  textTransform: "capitalize",
                }}
              >
                No data available
              </div>
            </div>
          ) : (
            <></>
          )}

          <div
            style={{
              overflowX: "hidden",
              overflowY: "hidden",
              minHeight: "calc(100vh - 127px)",
              width: "100%",
            }}
          >
            <div className={styles.kanbanBoard}>
              {taskBoardloading === false ? (
                <>
                  {tasks &&
                    filteredTasks?.map((column: any) => (
                      <div key={column.id} className={styles.kanbanColumn}>
                        <div className={styles.kanbanColumnHead}>
                          <div className={styles.kanbanColumnHeadTitle}>
                            {column?.stateName
                              ?.toLowerCase()
                              ?.replace(/_/g, " ")}
                          </div>

                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            {(userById?.roleCode === "SUPER_ADMIN" ||
                              userById?.roleCode === "ADMIN") &&
                              (localTaskCount || taskCountLength)?.data?.filter(
                                (task: any) =>
                                  task?.stateName === column.stateName,
                              )?.[0]?.tasksCount > 0 && (
                                <img
                                  src={Remainder}
                                  onClick={() => {
                                    setIsOpen(true);
                                    setStateName(column?.stateName);
                                    setCardType("STAGE");
                                    setTextForReminder(
                                      `You have few task pending in ${
                                        column?.stateName === "TO_DO"
                                          ? "To Do"
                                          : column?.stateName === "IN_PROGRESS"
                                            ? "In Progress"
                                            : "Blocked"
                                      } stage. Please complete it soon.`,
                                    );
                                  }}
                                />
                              )}

                            <div className={styles.kanbanColumnHeadCount}>
                              {
                                // ?.filter((task: any) => {
                                //   if (leadSearchTerm === "") {
                                //     return true;
                                //   }
                                //   const fullName = task.studentName;
                                //   return fullName
                                //     .toLowerCase()
                                //     .includes(leadSearchTerm.toLowerCase());
                                // })
                                // ?.filter((task: any) => {
                                //   if (filterCheckedPriorities.length === 0) {
                                //     return true;
                                //   }
                                //   return filterCheckedPriorities.some(
                                //     (item) =>
                                //       task.priority.toLowerCase() ===
                                //       item.priority.toLowerCase()
                                //   );
                                // })
                                // ?.filter((task: any) => {
                                //   if (filterCheckedTypes.length === 0) {
                                //     return true;
                                //   }
                                //   return filterCheckedTypes.some(
                                //     (item) => task.taskType === item.type
                                //   );
                                // })
                                (
                                  localTaskCount || taskCountLength
                                )?.data?.filter(
                                  (task: any) =>
                                    task?.stateName === column.stateName,
                                )?.[0]?.tasksCount
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                Array.from(new Array(3)).map((_, index) => (
                  <div
                    key={index}
                    className={styles.kanbanColumn}
                    style={{ marginBottom: "8px" }}
                  >
                    <div className={styles.kanbanColumnHead}>
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={210}
                        height={25}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
            <div
              className={styles.kanbanBoardLeadsWrap}
              style={{
                maxHeight: `calc(100vh - 206px)`,
                overflowY: "auto",
                minHeight: `calc(78vh - 45.6px)`,
                overflowX: "hidden",
                width: "100%",
              }}
            >
              {taskBoardloading === false ? (
                <>
                  {tasks &&
                    filteredTasks?.map((column: any) => (
                      <div
                        key={column.id}
                        className={styles.kanbanColumnLeads}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={(event) =>
                          handleDrop(event, column.stateName, column.stateName)
                        }
                      >
                        {dropZoneActive ? (
                          <div className={styles.dropZoneBox}></div>
                        ) : (
                          <InfiniteScroll
                            dataLength={column?.tasks?.data?.length}
                            next={() => handleNextPage(column.stateName)}
                            hasMore={column?.tasks?.hasMore}
                            loader={
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {
                                  // <PuffLoader color="#36d7b7" />
                                }
                              </Box>
                            }
                            height={1400}
                          >
                            <div className={styles.kanbanColumnTasks}>
                              {column?.tasks?.data
                                ?.filter(
                                  (task: any) =>
                                    task?.status === column.stateName,
                                )
                                // ?.filter((task: any) => {
                                //   if (leadSearchTerm === "") {
                                //     return true;
                                //   }
                                //   const fullName = task.studentName;
                                //   const isDemoTask = task.taskType === "DEMO";

                                //   if (isDemoTask) {
                                //     const batchName =
                                //       task?.demoData?.[0]?.batchName;
                                //     return batchName
                                //       ? batchName
                                //           .toLowerCase()
                                //           .includes(
                                //             leadSearchTerm.toLowerCase()
                                //           )
                                //       : false;
                                //   }

                                //   return fullName
                                //     .toLowerCase()
                                //     .includes(leadSearchTerm.toLowerCase());
                                // })
                                // ?.filter((task: any) => {
                                //   if (filterCheckedPriorities.length === 0) {
                                //     return true;
                                //   }
                                //   return filterCheckedPriorities.some(
                                //     (item) =>
                                //       task.priority.toLowerCase() ===
                                //       item.priority.toLowerCase()
                                //   );
                                // })
                                // ?.filter((task: any) => {
                                //   if (filterCheckedTypes.length === 0) {
                                //     return true;
                                //   }
                                //   return filterCheckedTypes.some(
                                //     (item) => task.taskType === item.type
                                //   );
                                // })
                                ?.sort((a: any, b: any) => {
                                  const dateA = a?.date || 0;
                                  const dateB = b?.date || 0;
                                  return dateA - dateB;
                                })
                                ?.map((task: any) => {
                                  const taskIdForHighlight =
                                    task.id || task.activityId;
                                  const isHighlighted =
                                    highlightedTaskId &&
                                    (String(highlightedTaskId) ===
                                      String(task.id) ||
                                      String(highlightedTaskId) ===
                                        String(task.activityId) ||
                                      String(highlightedTaskId) ===
                                        String(taskIdForHighlight));

                                  return (
                                    <div
                                      key={task.id || task.activityId}
                                      className={`${styles.kanbanTask} ${
                                        isHighlighted
                                          ? styles.highlightedTask
                                          : ""
                                      }`}
                                      id={`task-${taskIdForHighlight}`}
                                      draggable
                                      onDragStart={(event) =>
                                        handleDragStart(
                                          event,
                                          column.stateName,
                                          taskIdForHighlight,
                                          task.taskType,
                                          task,
                                        )
                                      }
                                    >
                                      <div className={styles.taskType}>
                                        <div
                                          className={styles.dateSelect}
                                          style={{
                                            color:
                                              moment(task?.date) < moment()
                                                ? "red"
                                                : "inherit",
                                          }}
                                        >
                                          {getFormattedDate(
                                            task?.date,
                                            task?.taskCategory,
                                          )}
                                        </div>
                                        <div className={styles.taskFlag}>
                                          <div
                                            className={styles.taskTypeSelect}
                                          >
                                            {task.taskType?.toLowerCase()}
                                          </div>
                                          <div className={styles.userCircle}>
                                            {getTeamMember(
                                              task?.assignedToId,
                                              employees,
                                            )?.firstName === undefined
                                              ? ""
                                              : getTeamMember(
                                                  task?.assignedToId,
                                                  employees,
                                                )?.firstName?.charAt(0) +
                                                "" +
                                                getTeamMember(
                                                  task?.assignedToId,
                                                  employees,
                                                )?.lastName?.charAt(0)}
                                          </div>
                                          <div className={styles.flagAssign}>
                                            {task.priority === "HIGH" && (
                                              <img src={High} alt="High" />
                                            )}
                                            {task.priority === "NORMAL" && (
                                              <img src={Normal} alt="Normal" />
                                            )}
                                            {task.priority === "LOW" && (
                                              <img src={Low} alt="Low" />
                                            )}
                                            {task.priority === "URGENT" && (
                                              <img src={Urgent} alt="Urgent" />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          width: "100%",
                                          minWidth: 0,
                                          display: "flex",
                                          alignItems: "flex-start",
                                          gap: "6px",
                                        }}
                                      >
                                        <div
                                          onClick={() => handleClick(task)}
                                          onMouseEnter={(e) => {
                                            if (
                                              task?.taskCategory?.toUpperCase() ===
                                              "GENERAL_TASK"
                                            ) {
                                              e.currentTarget.style.color =
                                                "#11C89B";
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (
                                              task?.taskCategory?.toUpperCase() ===
                                              "GENERAL_TASK"
                                            ) {
                                              e.currentTarget.style.color =
                                                "#142C44";
                                            }
                                          }}
                                          className={styles.taskDesc}
                                          style={{
                                            cursor:
                                              task?.taskCategory?.toUpperCase() ===
                                              "GENERAL_TASK"
                                                ? "pointer"
                                                : "default",
                                            flex: 1,
                                            minWidth: 0,
                                          }}
                                        >
                                          {(task?.taskCategory &&
                                            (task?.taskTitle?.length > 25
                                              ? task.taskTitle.substring(
                                                  0,
                                                  25,
                                                ) + "..."
                                              : task?.taskTitle)) ||
                                            ""}
                                          {task?.taskCategory?.toUpperCase() ===
                                            "GENERAL_TASK" &&
                                            !!(
                                              task?.recurringTaskId ||
                                              task?.recurrence ||
                                              task?.recurringInfo ||
                                              task?.isRecurring
                                            ) && (
                                              <Tooltip
                                                title="Recurrence Task"
                                                arrow
                                              >
                                                <LoopIcon
                                                  sx={{
                                                    fontSize: "14px",
                                                    color: "#11C89B",
                                                    marginLeft: "6px",
                                                    verticalAlign: "Middle",
                                                  }}
                                                />
                                              </Tooltip>
                                            )}
                                        </div>
                                      </div>
                                      <div
                                        className={styles.lead}
                                        onClick={() =>
                                          task.taskType === "DEMO"
                                            ? navigate(
                                                `/app/Tasks/DemoTaskDetails/${task.id}`,
                                              )
                                            : hasLeadCardPermission
                                              ? !hasAllBranchAccess &&
                                                userById?.branchId !==
                                                  task?.branchId
                                                ? dispatch(
                                                    setToastNotification({
                                                      message: String(
                                                        "You do not have all branches access and this lead belongs to different a branch",
                                                      ),
                                                      type: "error",
                                                      snackOpen: true,
                                                    }),
                                                  )
                                                : openLeadExpandModal(
                                                    task?.instituteId
                                                      ? task?.instituteId
                                                      : task?.enquiryData
                                                          ?.instituteId,
                                                    task?.studentContact
                                                      ? task?.studentContact
                                                      : task?.enquiryData
                                                          ?.studentContact,
                                                    task?.studentEmail
                                                      ? task?.studentEmail
                                                      : task?.enquiryData
                                                          ?.studentEmail,
                                                    task?.enquiryId,
                                                    dispatch,
                                                    "task",
                                                    task.id,
                                                    "INCOMPLETE",
                                                  )
                                              : dispatch(
                                                  setToastNotification({
                                                    message: String(
                                                      "You do not have permission to access the lead card",
                                                    ),
                                                    type: "error",
                                                    snackOpen: true,
                                                  }),
                                                )
                                        }
                                      >
                                        {task?.taskType === "DEMO" ? (
                                          <>{task?.demoData?.[0]?.batchName}</>
                                        ) : (
                                          <>{task.studentName}</>
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {task?.taskType === "DEMO" ? (
                                          <>
                                            <div
                                              className={styles.taskTitle}
                                              style={{
                                                display: "flex",
                                                gap: "2px",
                                              }}
                                            >
                                              <div
                                                className={
                                                  styles.taskDemoItemLabel
                                                }
                                              >
                                                Time:
                                              </div>
                                              <div
                                                className={
                                                  styles.taskDemoItemValue
                                                }
                                              >
                                                {moment(
                                                  task?.demoData?.[0]
                                                    ?.demoStartTime,
                                                ).format(" hh:mm A") +
                                                  " to " +
                                                  moment(
                                                    task?.demoData?.[0]
                                                      ?.demoEndTime,
                                                  ).format(" hh:mm A")}
                                              </div>
                                            </div>
                                            <div
                                              className={styles.taskTitle}
                                              style={{
                                                display: "flex",
                                                gap: "2px",
                                              }}
                                            >
                                              <div>Course:</div>
                                              <div>
                                                {task?.enquiryData?.courseName}
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <div
                                            className={styles.taskDesc}
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                getDescriptionWithMentionedNames(
                                                  task?.description,
                                                  employees,
                                                ).replace(/\n/g, "<br>"),
                                            }}
                                          ></div>
                                        )}
                                        {(userById?.roleCode ===
                                          "SUPER_ADMIN" ||
                                          userById?.roleCode === "ADMIN") &&
                                          !task.taskCategory && (
                                            <img
                                              src={Remainder}
                                              onClick={() => {
                                                handleSendRemainders(
                                                  task?.id,
                                                  "CARD",
                                                );
                                                setTaskId(task?.id);
                                                setCardType("CARD");
                                                setTextForReminder(
                                                  "Do you want to send bulk reminders for the task?",
                                                );
                                              }}
                                            />
                                          )}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </InfiniteScroll>
                        )}
                      </div>
                    ))}
                </>
              ) : (
                Array.from(new Array(3)).map((_, index) => (
                  <div key={index} className={styles.kanbanColumn}>
                    <div className={styles.kanbanColumnTasks}>
                      <Skeleton
                        animation="wave"
                        variant="rectangular"
                        height="60vh"
                        style={{
                          marginBottom: "10px",
                          borderRadius: "3px",
                        }}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </Box>
      <Box
        sx={{
          background: "#fff",
          width: "360px",
          borderLeft: "1px solid #E9E9E9",
        }}
        className="datepicker-container"
      >
        {taskBoardloading === false ? (
          <>
            <DateRangePicker
              startDate={rangeStartDate}
              endDate={rangeEndDate}
              onDateChange={onDateChange}
              minDate={moment().toDate()}
            />

            {rangeEndDate &&
              moment(rangeEndDate).startOf("day").unix() * 1000 >
                moment().startOf("day").unix() * 1000 && (
                <div
                  style={{
                    padding: "0 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginBottom: "20px",
                  }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleResetDate}
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                    size="small"
                  >
                    Reset Date
                  </Button>
                </div>
              )}
          </>
        ) : (
          <>
            <div style={{ padding: "10px" }}>
              <Skeleton
                animation="wave"
                variant="rectangular"
                height="40px"
                style={{
                  borderRadius: "3px",
                  marginBottom: "10px",
                }}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                height="290px"
                style={{
                  borderRadius: "3px",
                }}
              />
            </div>
          </>
        )}

        <div style={{ padding: "0px 20px 20px 20px" }}>
          {taskBoardloading === false ? (
            <>
              <div className={styles.taskCompletedWrap}>
                <div className={styles.taskCompletedWrapHead}>Completed</div>
                <div
                  className={styles.taskCompletedWrapViewAll}
                  onClick={() =>
                    navigate(
                      selectedTeamMember?.length > 0
                        ? `/app/Tasks/TaskCompleted?selectedUsers=${selectedTeamMember[0]?.id}`
                        : `/app/Tasks/TaskCompleted`,
                      { state: { taskSelectedId: selectedTeamMember[0]?.id } },
                    )
                  }
                >
                  View all
                </div>
              </div>
              <div
                className={styles.taskCompletedListWrap}
                onDragOver={handleDragOver}
                // onDragLeave={handleDragLeave}
                onDrop={(event) => handleCompletedDrop(event)}
                style={{
                  position: "relative",
                  maxHeight:
                    rangeEndDate &&
                    moment(rangeEndDate).startOf("day").unix() * 1000 >
                      moment().startOf("day").unix() * 1000
                      ? "calc(100vh - 460px)"
                      : "calc(100vh - 440px) ",
                  minHeight:
                    rangeEndDate &&
                    moment(rangeEndDate).startOf("day").unix() * 1000 >
                      moment().startOf("day").unix() * 1000
                      ? "calc(100vh - 460px)"
                      : "calc(100vh - 440px)",
                }}
              >
                {dropZoneActive ? (
                  <div
                    style={{
                      border: "2px dashed #11c89b",
                      width: "100%",
                      maxHeight:
                        rangeEndDate &&
                        moment(rangeEndDate).startOf("day").unix() * 1000 >
                          moment().startOf("day").unix() * 1000
                          ? "calc(100vh - 480px)"
                          : "calc(100vh - 460px) ",
                      minHeight:
                        rangeEndDate &&
                        moment(rangeEndDate).startOf("day").unix() * 1000 >
                          moment().startOf("day").unix() * 1000
                          ? "calc(100vh - 480px)"
                          : "calc(100vh - 460px)",
                    }}
                  ></div>
                ) : (
                  <>
                    {tasksByAssignee &&
                      completedTasks &&
                      completedTasksEmpty === true && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            right: "0",
                            bottom: "0",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                              color: "#667085",
                              fontWeight: "600",
                              marginBottom: "6PX",
                            }}
                          >
                            No data available
                          </div>
                          <div
                            style={{
                              fontSize: "13px",
                              textAlign: "center",
                              color: "#667085",
                            }}
                          >
                            Drag and drop the completed task after completion
                          </div>
                        </div>
                      )}
                    {tasks && completedTasks && (
                      <InfiniteScroll
                        dataLength={completedTasks?.tasks?.data?.length}
                        next={() => handleNextPage(completedTasks?.stateName)}
                        hasMore={completedTasks?.tasks?.hasMore}
                        loader={
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {
                              // <PuffLoader color="#36d7b7" />
                            }
                          </Box>
                        }
                        height={
                          rangeEndDate &&
                          moment(rangeEndDate).startOf("day").unix() * 1000 >
                            moment().startOf("day").unix() * 1000
                            ? "calc(100vh - 460px)"
                            : "calc(100vh - 440px)"
                        }
                      >
                        {tasks &&
                          completedTasks?.tasks?.data
                            ?.slice()
                            .sort((a: any, b: any) => {
                              const dateA =
                                a?.taskCompletedDate || a?.date || 0;
                              const dateB =
                                b?.taskCompletedDate || b?.date || 0;
                              return dateB - dateA;
                            })
                            ?.map((task: any) => (
                              <CompletedCard
                                taskCompletedPage={false}
                                task={task}
                                expandDisabled={false}
                                employees={employees}
                                page="TASK_BOARD"
                                handleDragStart={handleDragStart}
                                onTaskClick={handleClick}
                                highlightedTaskId={highlightedTaskId}
                              />
                            ))}
                      </InfiniteScroll>
                    )}
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              {Array.from(new Array(4)).map((_, index) => (
                <div key={index} className={styles.tableSkeletonBodyItem}>
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width="100%"
                    height={50}
                  />
                </div>
              ))}
            </>
          )}
        </div>
      </Box>
      <RemainderPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        handlePopupYesButton={handlePopupYesButton}
        handlePopupNoButton={handlePopupNoButton}
        loading={sendRemaindersLoading}
        textForReminder={textForReminder}
      />

      <Drawer
        anchor="right"
        open={!!selectedGeneralTaskId}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: "380px", md: "500px" },
            backgroundColor: "#FFF",
          },
        }}
        sx={{ zIndex: 9 }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#FFF",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #E9E9E9",
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#101828",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "calc(100% - 80px)",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              {taskById?.taskTitle || "Task Details"}
            </Typography>
            <IconButton
              onClick={handleClose}
              size="small"
              sx={{
                position: "absolute",
                left: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#000000",
                padding: "5px",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
                borderRadius: "5px",
                zIndex: 10,
                backgroundColor: "#fff",
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              padding: "0",
            }}
          >
            {selectedGeneralTaskId && (
              <TaskDetails
                initialTaskId={selectedGeneralTaskId}
                tasks={tasks}
                DeleteTask={DeleteTask}
                UpdateTaskStatus={UpdateTaskStatus}
                selectedLeadData={selectedLeadData || null}
                employees={employees}
                CreateComment={CreateComment}
                DeleteComment={DeleteComment}
                EditComment={EditComment}
                EditTask={EditTask}
                CreateTask={CreateTask}
                taskTypes={tasksTypes}
                setFromTaskEdit={setFromTaskEdit}
                setTaskForEditing={setTaskForEditing}
                setShowAddTask={setShowAddTask}
                showAddTask={showAddTask}
                isInDrawer={true}
                onCloseDrawer={handleClose}
              />
            )}
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
